import { takeLatest, put, call } from 'redux-saga/effects';
import { loginSuccess, loginFail, 
    logoutSuccess, logoutFail, 
    getAuthUserSuccess, getAuthUserFail,
    getAuthUserModuleSuccess, getAuthUserModuleFail,
	getUserProfileSuccess, getUserProfileFail,
	doChangePasswordSuccess, doChangePasswordFail
 } from './authState';
import authservice from '../../services/authservice';
import { showLoading, hideLoading } from '../layout/layoutState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';
import { setCrudRoute } from '../../redux/crud/crudState';

const crudService = createCrudService('api/v1/auth');

function* loginUser(action) {
  	try {
    
    	yield put(showLoading('Authenticating...'));
    	const { username, password } = action.payload;
    	const authToken = yield call(authservice.login, username, password); 

    	if(authToken){	
      		yield put(loginSuccess(authToken));
      		
			yield put({ type: 'auth/getAuthUser' });
			
			yield put({ type: 'auth/getAuthUserModule' });
			
		}
  	} catch (error) {
    	console.log(error.message);
    	yield put(loginFail(error.message));
  	}finally{
		yield put(hideLoading());
  	}
}

function* logoutUser(action) {
	yield put(showLoading('Logging out...'));
    try {
      
      	const authToken = yield call(authservice.logout); 
      	yield put(logoutSuccess(authToken));
  		
    } catch (error) {
      	yield put(logoutFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
  }

function* getAuthUser(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUser); 
        yield put(getAuthUserSuccess(user));

    } catch (error) {
        yield put(getAuthUserFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* getAuthUserModule(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUserModules); 
        yield put(getAuthUserModuleSuccess(user));

    } catch (error) {
        yield put(getAuthUserModuleFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* getUserProfile(action) {
	yield put(showLoading());
    try {
        const user = yield call(authservice.getCurrentUserProfile); 
        yield put(getUserProfileSuccess(user));

    } catch (error) {
        yield put(getUserProfileFail(error.message));
    }finally{
		yield put(hideLoading());
  	}
}

function* doChangePassword(action){
	yield put(showLoading());
    try {
        const user = yield call(authservice.doChangePassword, action.payload); 
        yield put(doChangePasswordSuccess(user));

		yield put(setCrudRoute({route:'/console/dashboard', mode: 'list', recordId:0 }));

    } catch (error) {
        yield put(doChangePasswordFail(error.message));
    }finally{
		yield put(hideLoading());
  	}

	// yield doCrudCall(
	// 	() => authservice.doChangePassword(data.payload), 
	// 	doChangePasswordSuccess, 
	// 	doChangePasswordFail,
	// 	"Change password successful.",
	// 	{route:'/console/dashboard', mode: 'list', recordId:0 }, UPDATING_MSG);	
}

function* authSaga() {
  	yield takeLatest('auth/loginRequest', loginUser);
  	yield takeLatest('auth/logoutRequest', logoutUser);
  	yield takeLatest('auth/getAuthUser', getAuthUser);
  	yield takeLatest('auth/getAuthUserModule', getAuthUserModule);
	yield takeLatest('auth/getUserProfile', getUserProfile);
	yield takeLatest('auth/doChangePassword', doChangePassword);
}

export default authSaga;
